/** Add two numbers */
export default function add(a: number, b: number) {
  return a + b;
}
